import { API_ENDPOINTS } from '../config/api-config';

let translationCache = {};
let locale: string;

const fetchTranslations = async (loc?: string) => {
  try {
    if (loc) locale = loc; // Set the locale for caching
    const response = await fetch(API_ENDPOINTS.TRANSLATIONS(loc || 'en-us'));
    if (!response.ok) {
      throw new Error('Failed to fetch translations');
    }
    const translations = await response.json();
    translationCache = translations; // Cache the full translations object
  } catch (error) {
    console.error(error);
    translationCache = {}; // Fallback to an empty object
  }
};

const initTranslations = async (loc?: string) => {
  if (Object.keys(translationCache).length === 0) {
    await fetchTranslations(loc);
  }
};

const t = (key) => {
  // Ensure cache exists
  if (!translationCache || Object.keys(translationCache).length === 0) {
    initTranslations(locale).then(
      () => translationCache[key], // Fallback to key if translations are not available
    );
  }

  const transWord = translationCache[key];
  return transWord || key; // Return the translation or the key if not found
};

export { t, initTranslations };
